import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { submitContactForm } from '../services/api';
import Navbar from './Navbar';
import Footer from './Footer';
import { Helmet } from 'react-helmet-async';
import './ContactUs.css';

const ContactUs = ({ user }) => {
    // const navigate = useNavigate(); // Unused for now
    const [formData, setFormData] = useState({
        name: '',
        brandName: '',
        email: '',
        contactNumber: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!formData.name.trim() || !formData.email.trim() || !formData.contactNumber.trim()) {
            setError('Please fill in all required fields');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setError('Please enter a valid email address');
            return;
        }

        setLoading(true);

        try {
            const response = await submitContactForm(formData);
            if (response.success) {
                setSuccess(true);
            } else {
                setError(response.message || 'Failed to submit form');
            }
        } catch (err) {
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-editorial-container">
            <Helmet>
                <title>Contact Us - Collaboration World</title>
                <meta name="description" content="Get in touch with Collaboration World. Start your influencer marketing journey with us today." />
                <link rel="canonical" href="https://www.collaborationworld.in/contact" />
            </Helmet>

            {/* Navigation Header */}
            <Navbar user={user} />

            <div className="editorial-wrapper">
                {/* Minimal Text Hero */}
                <div className="editorial-hero">
                    <h1>Customer Service</h1>
                    <p>We are at your disposal to answer any questions.</p>
                </div>

                <div className="editorial-grid">
                    {/* Left Column: Form */}
                    <div className="editorial-form-section">
                        <h2>Send a Message</h2>
                        {success ? (
                            <div className="editorial-success">
                                <h3>Thank you for your message.</h3>
                                <p>A member of our team will contact you shortly.</p>
                                <button onClick={() => setSuccess(false)} className="btn-text-only">Send another message</button>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} className="editorial-form">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Name *"
                                        required
                                    />
                                </div>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        name="brandName"
                                        value={formData.brandName}
                                        onChange={handleChange}
                                        placeholder="Brand Name"
                                    />
                                </div>
                                <div className="input-group">
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email Address *"
                                        required
                                    />
                                </div>
                                <div className="input-group">
                                    <input
                                        type="tel"
                                        name="contactNumber"
                                        value={formData.contactNumber}
                                        onChange={handleChange}
                                        placeholder="Phone Number *"
                                        required
                                    />
                                </div>
                                <div className="input-group">
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Message"
                                        rows="1" // Starts small, auto-expand could be added but keeping simple for now
                                    />
                                </div>

                                {error && <div className="editorial-error">{error}</div>}

                                <button type="submit" className="btn-editorial-submit" disabled={loading}>
                                    {loading ? 'SENDING...' : 'SEND MESSAGE'}
                                </button>
                            </form>
                        )}
                    </div>

                    {/* Right Column: Info & Map */}
                    <div className="editorial-info-section">
                        <div className="info-block">
                            <h2>Opening Hours</h2>
                            <p>Monday - Saturday: 10:00 AM - 7:00 PM</p>
                            <p>Sunday: Closed</p>
                        </div>

                        <div className="info-block">
                            <h2>Contact Details</h2>

                            <div className="contact-links">
                                <a href="tel:+917838280563">
                                    <i className="ri-phone-line"></i> +91 78382 80563
                                </a>
                                <a href="mailto:info.collaborationworl@gmail.com">
                                    <i className="ri-mail-line"></i> info.collaborationworl@gmail.com
                                </a>
                                <a href="https://wa.me/917838280563" target="_blank" rel="noopener noreferrer">
                                    <i className="ri-whatsapp-line"></i> Message on WhatsApp: +91 783 828 0563
                                </a>
                                <a href="https://instagram.com/collaborationworld" target="_blank" rel="noopener noreferrer">
                                    <i className="ri-instagram-line"></i> Instagram: @collaborationworld
                                </a>
                            </div>
                            <address style={{ marginTop: '1rem' }}>
                                New Delhi, India<br />
                            </address>
                        </div>


                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default ContactUs;
